import { supabase } from './supabase';

export type TopicPlayCount = { topicId: string; plays: number };

const CACHE_MS = 60 * 60 * 1000;
let cached: { at: number; counts: Map<string, number> } | null = null;
let inflight: Promise<Map<string, number>> | null = null;

async function loadPlayCounts(): Promise<Map<string, number>> {
  const { data, error } = await supabase.rpc('get_topic_play_counts');
  const map = new Map<string, number>();
  if (error || !data) return map;
  for (const row of data as { topic_id: string; plays: number | string }[]) {
    const id = String(row.topic_id ?? '');
    const plays = Number(row.plays) || 0;
    if (id && plays > 0) map.set(id, plays);
  }
  return map;
}

export async function fetchTopicPlayCounts(): Promise<Map<string, number>> {
  if (cached && Date.now() - cached.at < CACHE_MS) return cached.counts;
  if (inflight) return inflight;

  inflight = loadPlayCounts()
    .then((counts) => {
      cached = { at: Date.now(), counts };
      return counts;
    })
    .finally(() => {
      inflight = null;
    });

  return inflight;
}

export function formatPlayCount(plays: number) {
  if (plays < 1000) return String(plays);
  if (plays < 10_000) return `${(plays / 1000).toFixed(1).replace(/\.0$/, '')}k`;
  return `${Math.round(plays / 1000)}k`;
}
